// Mirrors DocumentPacketStatus on the backend. DRAFT and SIGNED are not offered as filters: a
// send row is only ever created once a packet leaves DRAFT, and SIGNED is not produced today.
export const STATUS_FILTER_OPTIONS = [
  { value: "", label: "Any status" },
  { value: "SENT", label: "Sent, awaiting signature" },
  { value: "CLIENT_SIGNED", label: "Client signed, admin to finish" },
  { value: "COMPLETED", label: "Completed" },
  { value: "EXPIRED", label: "Signing link expired" },
];

export const STATUS_COLOURS = {
  SENT: "warning",
  CLIENT_SIGNED: "info",
  COMPLETED: "success",
  EXPIRED: "error",
};
